import styled from "styled-components"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  ContainerStyles,
  ContentWrapperStyles,
  ModalImageStyles,
  ModalVideoStyles,
  SectionWrapperStyles,
  WrapperStyles,
} from "./media-styles"
import { BreakPoints, media } from "../../helpers/rwd"

export const SectionWrapper = styled.section`
  ${SectionWrapperStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  margin: 70px auto;
  ${media.max(BreakPoints.desktop)} {
    overflow-x: scroll;
    margin-top: 50px;
  }
  ${media.max(BreakPoints.phone)} {
    margin-top: 30px;
    margin-bottom: 50px;
  }
  ${ContentWrapperStyles}
`

export const Container = styled.div`
  display: flex;
  ${media.min(BreakPoints.desktop)} {
    flex-wrap: wrap;
  }
  ${media.max(BreakPoints.desktop)} {
    // avoid margin collapsing
    &:last-child:after {
      content: "";
      width: 1px;
      flex-shrink: 0;
    }
  }
  ${ContainerStyles}
`

export const Wrapper = styled.div`
  display: flex;
  width: 30%;
  box-sizing: border-box;
  margin-right: 5%;
  &:nth-child(3n) {
    margin-right: 0;
  }
  ${media.max(BreakPoints.desktop)} {
    min-width: 400px;
    flex-shrink: 0;
    &:nth-child(3n) {
      margin-right: 30px;
    }
  }
  ${media.max(BreakPoints.tablet)} {
    min-width: 350px;
  }
  ${media.max(BreakPoints.phone)} {
    min-width: 300px;
  }
  ${WrapperStyles}
`

export const ModalImage = styled.img`
  width: 100%;
  ${ModalImageStyles}
`

export const ModalVideo = styled.video`
  ${ModalVideoStyles}
`
